import { isString } from "lodash";

type GetRegionFullNameParams = {
  depth1?: string;
  depth2?: string | null;
  depth3?: string | null;
  fallback: string;
};

export function getRegionFullName({
  depth1,
  depth2,
  depth3,
  fallback,
}: GetRegionFullNameParams): string {
  const fullName = [depth1, depth2, depth3].filter(isString).join(" ").trim();
  return fullName.length > 0 ? fullName : fallback;
}
